import { useState } from 'react';
import { navigateToCohost } from 'src/functions/communityNameGenerator/navigateToCohost';

const useIdealMemberSubmission = (
  idealMember: string,
  generationMode = 'generator'
): {
  handleIdealMemberSubmit: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  inputError: string;
} => {
  const [inputError, setInputError] = useState<string>(null);

  const handleIdealMemberSubmit = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (idealMember?.length > 60) {
      setInputError('Must be less than 60 characters');

      return;
    } else if (idealMember?.length <= 3) {
      setInputError('Please enter more about who you want to bring together');

      return;
    }

    setInputError(null);
    navigateToCohost({
      idealMember,
      event,
      mode: generationMode,
    });
  };

  return {
    handleIdealMemberSubmit,
    inputError,
  };
};

export default useIdealMemberSubmission;
